import React from "react";

// router
import { useNavigate } from "react-router-dom";

// components
// import RevealContent from "../../../components/animation/RevealContent";
import heroimg from "../../../assets/images/pages/office.jpg";
import HeroSection from "../../../components/ui/Cards/Hero";
import servicespld from "../../../assets/images/imgplaceholders/servicespld.png";
// import ButtonLink from "../../../components/ui/links/ButtonLink";

// dispatch and state
import { advert_services } from "../../../service/api/service";
import { useAppDispatch, useAppSelector } from "../../../store";
import { FaCheck, FaChevronRight } from "react-icons/fa";
import Button from "../../../components/elements/form/Button";
import ArrowButton from "../../../components/ui/links/ArrowButton";

const Services = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const services = useAppSelector(({ service }) => service.services);

  const onLoad = React.useCallback(() => {
    advert_services(dispatch);
  }, [dispatch]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  return (
    <main className="w-full">
      <HeroSection
        title="Our Services"
        titleColor="text-white"
        description="Set up organisation and companies from incorporation, Website development, Register it with regulatory bodies, Train Staffs and introduce new companies to our database. "
        descriptionColor="text-white"
        buttonText="Contact Us"
        buttonLink="/contact-us"
        imageSrc={heroimg}
        imgPlaceHolder={servicespld}
        imageAlt="Hero Section"
        imagePosition="right"
        imagePositionBgColor="bg-customyellow/20"
        imageRotation="rotate-3"
        background="bg-primary-900"
        buttonbg="bg-primary-500"
        buttonTextColor="text-primary-950"
        buttonHoverBg="bg-primary-400"
        paddingtop="pt-20"
      />

      <section className="py-12 md:py-24 lg:py-32 bg-customgreen">
        <div className="max-w-7xl px-6 xl:px-0 mx-auto">
          <div className="flex flex-col items-center justify-center space-y-4 text-center mb-12">
            <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl text-primary-900">
              Our Services
            </h2>
            <p className="max-w-[700px] text-primary-700 md:text-xl/relaxed ">
              Get started with our comprehensive services and plans designed to
              help your business succeed.
            </p>
          </div>

          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {services.map((service) => (
              <div
                key={service.id}
                className="relative flex flex-col rounded-xl overflow-hidden border border-primary-200 shadow-md bg-white"
              >
                <div className="p-6">
                  <h3 className="text-xl font-bold text-primary-900 mb-2">
                    {service.name}
                  </h3>
                  <p
                    dangerouslySetInnerHTML={{ __html: service.description }}
                    className="text-primary-700 mb-6"
                  ></p>
                  <ul className="space-y-2 mb-6">
                    {service.packages.map((feature, index) => (
                      <li key={index} className="flex items-start">
                        <FaCheck className="h-5 w-5 text-primary-500 mr-2 mt-0.5 flex-shrink-0" />
                        <span className="text-primary-800">{feature.name}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="p-6 mt-auto bg-primary-50 border-t border-primary-100">
                  <Button
                    title="Learn More"
                    onHandler={() => navigate(`/services/${service.id}`)}
                    rightIcon={<FaChevronRight className="ml-1 h-4 w-4" />}
                    bg_color="bg-white"
                    bg_hoverColor="bg-primary-50"
                    className="w-full text-primary-700 hover:text-white border border-primary-200 hover:border-primary-300"
                  />
                </div>
              </div>
            ))}
          </div>

          <div className="mt-16 text-center">
            <h3 className="text-2xl font-bold text-primary-900 mb-6">
              All Plans Include
            </h3>
            <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 max-w-4xl mx-auto">
              {[
                "24/7 Customer Support",
                "Secure Document Storage",
                "Digital Signature Tools",
                "Mobile App Access",
                "Regular Compliance Updates",
                "Dedicated Account Manager",
                "Online Dashboard",
                "Email Notifications",
              ].map((feature, index) => (
                <div
                  key={index + 1}
                  className="flex items-center p-4 bg-primary-50/20 rounded-lg"
                >
                  <FaCheck className="h-5 w-5 text-primary-500 mr-2 flex-shrink-0" />
                  <span className="text-primary-800">{feature}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-16 text-center">
            <ArrowButton
              link="/contact"
              text="Contact Us"
              textColor="text-white"
              bgColor="bg-primary-900"
              hoverBgColor="bg-primary-700"
              iconColor="text-primary-900"
              iconBgColor="bg-white"
            />

            <p className="mt-4 text-primary-700">
              Need a tailored solution? Our team is ready to help.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Services;
